import { useMemo } from 'react';
import { PredefinedOption } from 'components/day-picker/DayPicker';
import { EXPIRY_PERIOD_OPTIONS } from 'containers/estimates/constants';
import { getDefaultExpiryDate } from 'containers/estimates/estimatesSlice';
import DateUtils from 'utils/dateUtils';

/**
 * Custom hook to generate predefined expiry date options
 * @returns Array of predefined expiry date options including custom option
 */
export const useExpiryDateOptions = (): PredefinedOption[] => {
  return useMemo(() => {
    const mappedOptions = EXPIRY_PERIOD_OPTIONS.map(option => {
      // Handle "No expiry" option - return null date
      if (option.days === 0) {
        return {
          label: option.btnLabel,
          date: null,
          closesOnSelect: true
        };
      }

      // Calculate date using the same logic as getDefaultExpiryDate
      const expiryDateString = getDefaultExpiryDate(DateUtils.getNow(), option.days);
      const calculatedDate = expiryDateString ? DateUtils.parseISODateString(expiryDateString) : null;
      return {
        label: `In ${option.btnLabel}`,
        date: calculatedDate,
        closesOnSelect: true
      };
    });

    // Add Custom option - null date means it doesn't match any specific date
    const customOption: PredefinedOption = {
      label: 'Custom',
      date: null,
      closesOnSelect: false,
      isCustom: true // Flag to identify custom option
    };

    return [...mappedOptions, customOption];
  }, []);
};
